function primePath(path) {
  var length = typeof path.getTotalLength === 'function' ? path.getTotalLength() : 0;

  if (!length || !isFinite(length)) {
    return 0;
  }

  path.style.strokeDasharray = String(length);
  path.style.strokeDashoffset = String(length);
  path.style.transition = 'none';

  return length;
}

function initializeSectionSquiggle(sectionElement, prefersReducedMotion) {
  var path = sectionElement.querySelector('.rs-events-here-squiggle__path');

  if (!path) {
    return function noop() {};
  }

  if (prefersReducedMotion) {
    path.style.transition = 'none';
    path.style.strokeDasharray = 'none';
    path.style.strokeDashoffset = '0';
    return function noop() {};
  }

  var length = primePath(path);

  if (!length) {
    return function noop() {};
  }

  var hasPlayed = false;

  function playAnimation() {
    if (hasPlayed) {
      return;
    }

    hasPlayed = true;
    path.style.transition = 'stroke-dashoffset 2200ms linear';
    path.style.strokeDashoffset = '0';
  }

  if (typeof window.IntersectionObserver !== 'function') {
    playAnimation();
    return function noop() {};
  }

  var observer = new window.IntersectionObserver(function onIntersect(entries) {
    entries.forEach(function handleEntry(entry) {
      if (!entry.isIntersecting) {
        return;
      }

      playAnimation();
      observer.unobserve(sectionElement);
      observer.disconnect();
    });
  }, {
    root: null,
    rootMargin: '0px 0px -10% 0px',
    threshold: 0.15,
  });

  observer.observe(sectionElement);

  return function cleanupSectionSquiggle() {
    observer.unobserve(sectionElement);
    observer.disconnect();
  };
}

export function initializeEventsHereSquiggleOnView() {
  if (typeof window === 'undefined') {
    return function noop() {};
  }

  var sections = Array.prototype.slice.call(document.querySelectorAll('.home-section--events-here'));

  if (!sections.length) {
    return function noop() {};
  }

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var cleanups = sections.map(function setupSection(sectionElement) {
    return initializeSectionSquiggle(sectionElement, prefersReducedMotion);
  });

  return function cleanupAllSections() {
    cleanups.forEach(function runCleanup(cleanup) {
      if (typeof cleanup === 'function') {
        cleanup();
      }
    });
  };
}
